<template>
  <div>
    <list
      ref="list"
      unit="销售单"
      row-key="Id"
      :page="page"
      :query-params="params"
      :show-checkbox="false"
      :show-query="showQuery"
      @status-change="statusFun"
      @reset-query="$emit('reset-select')"
      :reRowClick="true"
      :get-row-click-func="myRowClick"
      :pageSizes="[10, 20, 30, 40, 100, 1000]"
      :get-data-func="getDataFunc"
      :summaryMethod="summaryFunc"
      :show-summary="summaryShow"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="客户名称">
          <!-- <el-input
            v-model="params.CustomerName"
            @focus="addUnit"
            
            readonly
            placeholder="请选择"
          ></el-input>-->
          <customer @restaurants="setSupplier" :state="params.CustomerName" />
        </el-form-item>
        <el-form-item label="单据编号">
          <el-input
            clearable
            v-model="params.OrderNo"
            placeholder="请输入单据编号"
          />
        </el-form-item>
        <el-form-item label="销货单状态">
          <el-select
            v-model="params.SaleDocStatus"
            placeholder="请选择"
            clearable
          >
            <el-option label="已生成" :value="1"></el-option>
            <el-option label="未生成" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="订单来源">
          <el-select v-model="params.Source" placeholder="请选择" clearable>
            <el-option label="代客下单" :value="1"></el-option>
            <el-option label="自主下单" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="单据状态">
          <el-select v-model="params.Status" placeholder="请选择" clearable>
            <el-option label="草稿" :value="0"></el-option>
            <el-option label="未生效" :value="1"></el-option>
            <el-option label="已生效" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="出库状态">
          <el-select v-model="params.OutStatus" placeholder="请选择" clearable>
            <el-option label="未出库" :value="0"></el-option>
            <el-option label="部分出库" :value="1"></el-option>
            <el-option label="已出库" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="完成状态">
          <el-select
            v-model="params.CompleteStatus"
            placeholder="请选择"
            clearable
          >
            <el-option label="未完成" :value="0"></el-option>
            <el-option label="已完成" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="收款状态">
          <el-select
            v-model="params.ReceiptStatus"
            placeholder="请选择"
            clearable
          >
            <el-option label="未收款" :value="0"></el-option>
            <el-option label="挂账" :value="1"></el-option>
            <el-option label="已收款" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="单据日期">
          <el-date-picker
            v-model.trim="params.DocDateStart"
            placeholder="请选择日期"
            value-format="yyyy-MM-dd"
            style="width: 180px"
          ></el-date-picker>
          <span style="margin: 0 10px">-</span>
          <el-date-picker
            v-model.trim="params.DocDateEnd"
            placeholder="请选择日期"
            value-format="yyyy-MM-dd"
            style="width: 180px"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="预计交货日期" label-width="100px">
          <el-date-picker
            v-model.trim="params.DeliveryDateStart"
            placeholder="请选择日期"
            value-format="yyyy-MM-dd"
            style="width: 180px"
          ></el-date-picker>
          <span style="margin: 0 10px">-</span>
          <el-date-picker
            v-model.trim="params.DeliveryDateEnd"
            placeholder="请选择日期"
            value-format="yyyy-MM-dd"
            style="width: 180px"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="所属机构">
              <el-select size="mini" v-model="params.DpId" placeholder="请选择机构" clearable>
         
                  <el-option v-for="(item,key) in DpList" :key="key" :label="item.DpName" :value="item.DpId"></el-option>
           
              </el-select>
            </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="DpName" label="所属机构" min-width="100px" />
        <el-table-column prop="OrderNo" label="单据编号" />
        <el-table-column prop="DocDate" label="单据日期" min-width="110px">
          <template slot-scope="{ row }">{{
            row.DocDate.split(" ")[0]
          }}</template>
        </el-table-column>
        <el-table-column prop="DocDate" label="来源">
          <template slot-scope="{ row }">{{
            row.Source == 0 ? "自主下单" : row.Source == 1 ? "代客下单" : ""
          }}</template>
        </el-table-column>
        <el-table-column prop="CustomerName" label="客户名称">
          <template slot-scope="{ row }">{{ row.CustomerName }}</template>
        </el-table-column>
        <el-table-column prop="Amount" label="订单金额">
          <template slot-scope="{ row }">{{
            $commonJs.toThousands(row.Amount)
          }}</template>
        </el-table-column>
        <el-table-column prop="ClerkName" label="业务员">
          <template slot-scope="{ row }">{{ row.ClerkName }}</template>
        </el-table-column>
        <el-table-column prop="Status" label="单据状态">
          <template slot-scope="{ row }">
            <span v-if="row.Status == 0">草稿</span>
            <span v-else-if="row.Status == 1">未生效</span>
            <span v-else>已生效</span>
          </template>
        </el-table-column>
        <el-table-column prop="ReceiptStatus" label="收款状态">
          <template slot-scope="{ row }">
            <span v-if="row.ReceiptStatus == 0">未收款</span>
            <span v-else-if="row.ReceiptStatus == 1">挂账</span>
            <span v-else>已收款</span>
          </template>
        </el-table-column>
        <el-table-column prop="RefundStatus" label="退款状态">
          <template slot-scope="{ row }">
            <span v-if="row.RefundStatus == 1">退款待审</span>
            <span v-else-if="row.RefundStatus == 2">客户取消</span>
            <span v-else-if="row.RefundStatus == 3">同意退款</span>
            <span v-else-if="row.RefundStatus == 4">拒绝退款</span>
            <span v-else>无</span>
          </template>
        </el-table-column>
        <el-table-column prop="PayType" label="支付方式">
          <template slot-scope="{ row }">
            <span v-if="row.PayType == 1">余额支付</span>
            <span v-else-if="row.PayType == 2">信用支付</span>
            <span v-else-if="row.PayType == 3">微信支付</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="CompleteStatus" label="完成状态">
          <template slot-scope="{ row }">
            <span v-if="row.CompleteStatus == 0">未完成</span>
            <span v-else>已完成</span>
          </template>
        </el-table-column>
        <el-table-column prop="SaleDocStatus" label="销货单">
          <template slot-scope="{ row }" >
            <span v-if="row.SaleDocStatus == 0">未生成</span>
            <span v-else>已生成</span>
          </template>
        </el-table-column>
        <slot name="column"></slot>
      </template>
    </list>
    <unit-dialog
      ref="unitDialog"
      in-dialog
      selectable
      @select="setUnit"
      title="客户列表"
      :typeList="[1, 2]"
    />
  </div>
</template>
<script>
import customer from "@/components/common/customer/customer";
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import unitDialog from "@/components/basicinfo/basic/logistics/listDialog";

export default {
  mixins: [listMixin],
  components: { list, unitDialog, customer },
  beforeMount() {
    this.cApi.list({ pageSize: 100, pageIndex: 1 }).then((res) => {
      this.cList = res.Data;
      sessionStorage.setItem("cList", JSON.stringify(res.Data));
    });
  },
  mounted() {},
  data() {
    return {
      api: require("@/api/sale/sales").default,
      cApi: require("@/api/ba/tradeUnit").default,
      dpApi: require("@/api/ent/dp").default,
      cList: [],
      params: {
        OrderNo: "",
        CustomerId: null,
        CustomerName: "",
        DocDateStart: this.$commonJs.getDayOffset(-30),
        DocDateEnd: this.$commonJs.getDayOffset(0),
        DeliveryDateStart: "",
        DeliveryDateEnd: "",
        CouponCustomerState: null,
        Source: null,
        Status: null,
        SaleDocStatus: null,
        OutStatus: null,
        CompleteStatus: null,
        ReceiptStatus: null,
        BillType:0,
        DpId:null//所属门店
      },
      DpList:[],
      summaryShow: false,
      total:null
    };
  },
  created(){
    this.dpApi.parentList({DpType:1}).then(res => {
       
       this.DpList = res.Data;
     })
  },
  methods: {
    getDataFunc(params) {
      return new Promise((resolve, reject) => {
        this.api.list(params).then(res => {
          let times = Math.ceil(res.Count / params.pageSize);
          //判断是否最后一页
          if (times == params.pageIndex) {
            this.api.listTotal(params).then(res => {
              if (res.Code == 0 && res.Data) {
                this.total = res.Data[0];
                this.summaryShow = true;
              } else {
                this.summaryShow = false;
              }
            })
          } else {
            this.summaryShow = false;
          }
          resolve(res);
        })
      })
    },
    summaryFunc(param) {
      const { columns, data } = param;
      var fields = ['Amount']; //需要合计的字段
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        var field = fields.find(x => x == column.property);
        if (field) {
          console.log(field, index);
          sums[index] = "";
          if (this.total) {
            sums[index] = this.total[field].toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
          }
        } else {
          sums[index] = "";
        }
      });
      return sums;
    },
    setSupplier(data) {
      this.params.CustomerId = data.TradeUnitId;
      this.params.CustomerName = data.TradeUnitName;
      // this.params.CustomerType = data.TradeUnitType;
      console.log("data",data)
    },
    onExport() {
      var loading = this.$loading({
        lock: true,
        text: "正在导出...",
        spinner: "el-icon-loading",
        customClass: "my_loading",
        background: "rgba(0, 0, 0, 0.3)",
      });
      var params = this.$commonJs.obj.removeNullKey(this.params);
      this.api.export(params).then(() => {
        loading.close();
      });
    },
    myRowClick(row, column, e) {
      this.$emit("loading");
      this.api.info(row.OrderId).then((res) => {
        this.$emit("setDetails", res.Data.Goods, row);
        this.$emit("loading");
      });
    },
    statusFun(row, column) {
      if (column.property == "SaleDocStatus") {
        if (row.SaleDocStatus == 0) {
          this.$router.push({
            path: "bill",
            query: {
              OrderId: row.OrderId,
              OrderNo: row.OrderNo,
              canWrite: this.$permission.canWrite(),
            },
          });
        }
      }
    },
    addUnit(e) {
      this.$refs.unitDialog.open().then((that) => {
        that.getData({});
      });
    },
    setUnit(e) {
      this.params.CustomerId = e.Id;
      this.params.CustomerName = e.Name;
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>